import { render, staticRenderFns } from "./RejectionCauseUpdateContainer.vue?vue&type=template&id=afbfd3f2"
import script from "./RejectionCauseUpdateContainer.vue?vue&type=script&lang=js"
export * from "./RejectionCauseUpdateContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports